import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { TeamProfileService } from './team-profile/team-profile.service';
import * as _ from 'lodash';


@Injectable()
export class PaymentService {

    constructor(
        private _http: HttpClient,
        private _teamProfileService: TeamProfileService
    ) { }


    navigateToPayment() {

        this.getTeamUsersCount(localStorage.getItem('teamId'))
            .subscribe(
                (res: any) => {

                    let subscriptionValues = {
                        product: environment.APP_NAME,
                        plan: this.getParamValue('plan'),
                        users: res.data.count
                    }
                    this._teamProfileService.subscription(subscriptionValues)
                        .subscribe(
                            (res: any) => {
                                window.open(res.redirectUrl, "_self");
                            },
                            err => {
                                if (err.error.redirectUrl) {
                                    window.open(err.error.redirectUrl, "_self");
                                }
                                console.error(err.error.message);
                            }
                        )
                },
                err => {

                    console.error(err.error.message);
                }
            )
    }

    getTeamUsersCount(teamId) {
        return this._http.get(environment.serverUrl + '/user/count');
    }

    getParamValue(name) {
        const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
        if (!results) {
            return 0;
        }
        return results[1] || 0;
    }
}



// WEBPACK FOOTER //
// ./src/app/payment.service.ts